const profileFR = {
    "edit": {
        "title": "Modifier votre profil",
        "form": {
            "label": {
                "profileImage": "Image de profil",
                "streetAndNumber": "Ma rue et numéro de maison",
                "postalCode": "Code postal",
                "city": "Ville",
                "country": "Pays",
                "vatNumber": "Numéro de TVA",
                "nationalTaxNumber": "Numéro d'identification fiscale nationale",
                "businessRegistrationNumber": "Numéro d'enregistrement de l'entreprise",
                "vatStatus": "Statut de la TVA",
                "businessType": "Type d'entreprise",
                "vatExemptDocument": "Document d'exemption de TVA",
                "businessCertificate": "Certificat d'entreprise",
                "preferredPaymentMethod": "Méthode de paiement préférée",
                "paypalEmail": "Email Paypal",
                "accountHolderName": "Nom du titulaire du compte bancaire",
                "bankName": "Nom de la banque",
                "bankAddress": "Adresse de la banque",
                "iban": "IBAN"
            },
            "option": {
                "preferedMethod": {
                    "paypal": "Paypal",
                    "bankAccount": "Compte bancaire"
                }
            },
            "help_text": {
                "profileImage": "Téléchargez des formats JPG, résolution uniquement 300x300 px, taille max 300 KB.",
                "iban": "N'oubliez pas le préfixe de votre pays, par exemple DE, FR, ES"
            },
            "button": {
                "submit": "Soumettre"
            }
        },
        "message": {
            "success": "Votre profil a été mis à jour !",
            "error": "Quelque chose s'est mal passé ! Veuillez actualiser la page et réessayer !"
        },
        "modal": {
            "header": "Êtes-vous sûr de vouloir modifier votre profil ?",
            "body": "Par la présente, vous garantissez que toutes les données fournies sont véridiques. Vous êtes seul et légalement responsable des données fournies et de la véracité de ces informations.",
            "button": {
                "cancel": "Annuler",
                "confirm": "Confirmer"
            }
        }
    },
    "set_new_password": {
        "title": "Définir un nouveau mot de passe",
        "form": {
            "label": {
                "currentPassword": "Mot de passe actuel",
                "newPassword": "Nouveau mot de passe",
                "repeatNewPassword": "Répéter le nouveau mot de passe"
            },
            "button": {
                "submit": "Soumettre"
            },
            "validation": {
                "oldPasswordRequired": "Votre ancien mot de passe est requis",
                "newPasswordMin": "Votre mot de passe doit comporter au moins 10 caractères",
                "newPasswordRequired": "Le nouveau mot de passe est requis",
                "passwordsMustMatch": "Le nouveau mot de passe doit correspondre"
            }
        },
        "message": {
            "success": "Votre mot de passe a été changé !",
            "error": "Quelque chose s'est mal passé ! Veuillez actualiser la page et réessayer !"
        },
        "modal": {
            "header": "Êtes-vous sûr de vouloir changer votre mot de passe ?",
            "body": "Veuillez confirmer"
        }
    },
    "panel": {
        "label": {
            "emailAddress": "Adresse e-mail",
            "paypalEmailAddress": "Adresse e-mail Paypal",
            "phone": "Téléphone",
            "streetAndHouseNumber": "Rue et numéro de maison",
            "postalCode": "Code postal",
            "city": "Ville",
            "country": "Pays",
            "paymentMethod": "Méthode de paiement",
            "accountNumberHolder": "Titulaire du compte",
            "bankName": "Nom de la banque",
            "iban": "IBAN",
            "bic": "BIC",
            "bankAddress": "Adresse de la banque",
            "paypal": "Paypal",
            "bankAccount": "Compte bancaire"
        }
    },
    "payment_method": {
        "title": "Méthode de paiement",
        "label": {
            "card_number": "Numéro de carte",
            "card_expiry": "Expiration",
            "default_method": "Par défaut",
            "manage_method": "Gérer",
            "add_method": "Ajouter"
        }
    },
    "withholding_tax": {
        "title": "Retenue à la source",
        "form": {
            "label": {
                "taxPercentage": "Pourcentage de taxe",
                "whtStatus": "Statut WHT",
                "whtLicense": "Licence WHT"
            },
            "help_text": {
                "uploadDocument": "Veuillez télécharger votre document de retenue à la source."
            },
            "button": {
                "submit": "Soumettre",
                "removeFile": "Supprimer ?"
            },
            "message": {
                "whtStatusText": "Selon l'article 31 de la loi croate sur l'impôt sur les bénéfices, une retenue à la source de 15-25 % est appliquée aux non-résidents. Cependant, si vous résidez dans un pays ayant un Accord pour éviter la double imposition avec la Croatie, vous pouvez bénéficier d'un taux réduit. Vous pouvez vérifier si votre pays est répertorié sur <1><strong>ce lien</strong></1>.",
                "whtApplyRateText": "Pour demander le taux réduit, veuillez cliquer sur <1><strong>ce document</strong></1>. Téléchargez, complétez et soumettez le formulaire pour bénéficier du taux spécifié dans l'accord si éligible."
            }
        },
        "message": {
            "success": "Licence WHT soumise avec succès. Elle sera traitée par notre équipe.",
            "error": "Une erreur s'est produite lors de la mise à jour. Veuillez réessayer."
        }
    }
};

export default profileFR;